"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    fontFamily,
    basicFontSize,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccRangeDateTimePickerStyle = (0, _react.useMemo)(() => {
    const deviceDateTimePickerProps = () => {
      const display = isMobileView ? 'block' : 'inline-block';
      return {
        display
      };
    };
    const deviceAnchorBtnProps = () => {
      const width = isMobileView ? '100%' : 'auto';
      return {
        width
      };
    };
    const deviceTimeProps = () => {
      const width = isMobileView ? pxToRem(316) : 'auto';
      const margin = isMobileView ? `${pxToRem(12)} auto` : `${pxToRem(0)} auto`;
      return {
        width,
        margin
      };
    };
    const ccDateTimePicker = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: basicFontSize,
      ...deviceDateTimePickerProps()
    });
    const ccDateTimePickerAnchorBtn = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      gap: pxToRem(20),
      '& > div': {
        textAlign: 'center',
        lineHeight: 1,
        ...deviceAnchorBtnProps(),
        '& > div:nth-child(2)': {
          color: themeColors?.general.subText
        }
      },
      '& > div:nth-child(3)': {
        width: '1px',
        background: themeColors?.general.border
      }
    });
    const ccDateTimePickerInnerTitle = (0, _css.css)({
      fontSize: basicFontSize,
      fontWeight: 'bold',
      marginBottom: pxToRem(7),
      marginInlineStart: isMobileView ? pxToRem(6) : pxToRem(14)
    });
    const ccRangeDateTimePickerTimeSection = (0, _css.css)({
      display: 'flex',
      justifyContent: isMobileView ? 'flex-start' : 'space-evenly',
      ...deviceTimeProps(),
      '& > div:first-child': {
        width: pxToRem(120)
      },
      '& > div:last-child': {
        width: pxToRem(120)
      }
    });
    return {
      ccDateTimePicker,
      ccDateTimePickerAnchorBtn,
      ccDateTimePickerInnerTitle,
      ccRangeDateTimePickerTimeSection
    };
  }, [fontFamily, basicFontSize, pxToRem, themeColors?.general.border, isMobileView]);
  return {
    'cc-RangeDateTimePicker': ccRangeDateTimePickerStyle.ccDateTimePicker,
    'cc-RangeDateTimePicker__anchor-btn': ccRangeDateTimePickerStyle.ccDateTimePickerAnchorBtn,
    'cc-RangeDateTimePicker__inner-title': ccRangeDateTimePickerStyle.ccDateTimePickerInnerTitle,
    'cc-RangeDateTimePicker__time-container': ccRangeDateTimePickerStyle.ccRangeDateTimePickerTimeSection
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;